import React from 'react';
import SectionWrapper from '@/src/components/Layouts/Section/SectionWrapper';
import ItemWrapper from '@/src/components/Layouts/Item/Item';
import Row from '@/src/components/Layouts/Row/Row';
import Select from '@/src/components/Antd/Select/Select';
import Input from '@/src/components/Antd/NumberInput/NumberInput';
import css from './css.less';
import { useDispatch } from 'react-redux';
import { unitTypeList, unitSuffix } from '@/src/tools/config';
import { ConditionType } from '@/src/types/common/common';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
const Dimensions = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const dispatch = useDispatch();

  const { data = {}, setDimensions, disabled } = props;
  const {
    weight,
    weightUnit = {},
    measurementUnit = {},
    length,
    width,
    volume,
    height,
  } = data;

  const dimensionsOnChange = (setting) => {
    dispatch(setDimensions(setting));
  };
  return (
    <SectionWrapper
      title={getI18n(
        'allProducts.addproductset.dimensions_component_Dimensions_title',
      )}
      subtitle={getI18n(
        'allProducts.addproductset.dimensions_component_Dimensions_subtitle',
      )}>
      <Row
        containerClassName={css.dimensionsRowClass}
        elements={[
          {
            child: (
              <ItemWrapper title={getI18n('general.weight')}>
                <Input
                  size='large'
                  disabled={disabled}
                  placeholder='0.0'
                  onChange={(e) => {
                    if (dimensionsOnChange) dimensionsOnChange({ weight: e });
                  }}
                  value={weight}
                />
              </ItemWrapper>
            ),
          },
          {
            child: (
              <ItemWrapper title={<span>&nbsp;</span>}>
                <Select
                  disabled={disabled}
                  onChange={(e) => {
                    if (dimensionsOnChange)
                      dimensionsOnChange({ weightUnit: e });
                  }}
                  value={weightUnit}
                  optionsGroupList={unitTypeList[ConditionType.Weight]}
                  size='large'
                />
              </ItemWrapper>
            ),
          },
        ]}
      />
      <Row
        elements={[
          {
            child: (
              <ItemWrapper
                title={getI18n(
                  'allProducts.addproductset.dimensions_component_Dimensions_unitofMeasure',
                )}>
                <Select
                  disabled={disabled}
                  value={measurementUnit}
                  onChange={(value, option) => {
                    if (dimensionsOnChange)
                      dimensionsOnChange({
                        measurementUnit: value,
                      });
                  }}
                  optionsGroupList={unitTypeList[ConditionType.Length]}
                  size='large'
                />
              </ItemWrapper>
            ),
          },
          {
            child: <React.Fragment />,
          },
        ]}
      />
      <Row
        elements={[
          {
            child: (
              <ItemWrapper
                title={getI18n(
                  'allProducts.addproductset.dimensions_component_length',
                )}>
                <Input
                  disabled={disabled}
                  onChange={(e) => {
                    if (dimensionsOnChange) dimensionsOnChange({ length: e });
                  }}
                  value={length}
                  size='large'
                  placeholder='0'
                />
              </ItemWrapper>
            ),
          },
          {
            child: (
              <ItemWrapper
                title={getI18n(
                  'allProducts.addproductset.dimensions_component_Width',
                )}>
                <Input
                  disabled={disabled}
                  onChange={(e) => {
                    if (dimensionsOnChange) dimensionsOnChange({ width: e });
                  }}
                  value={width}
                  size='large'
                  placeholder='0'
                />
              </ItemWrapper>
            ),
          },
          {
            child: (
              <ItemWrapper
                title={getI18n(
                  'allProducts.addproductset.dimensions_component_Height',
                )}>
                <Input
                  disabled={disabled}
                  onChange={(e) => {
                    if (dimensionsOnChange) dimensionsOnChange({ height: e });
                  }}
                  value={height}
                  size='large'
                  placeholder='0'
                />
              </ItemWrapper>
            ),
          },
        ]}
      />
      <Row
        elements={[
          {
            child: (
              <ItemWrapper
                title={getI18n(
                  'allProducts.addproductset.dimensions_component_Volume',
                )}>
                <Input
                  disabled={disabled}
                  onChange={(e) => {
                    if (dimensionsOnChange) dimensionsOnChange({ volume: e });
                  }}
                  value={volume}
                  size='large'
                  placeholder='0.0'
                  suffix={unitSuffix[measurementUnit] + '3' || ''}
                />
              </ItemWrapper>
            ),
          },
          { child: <React.Fragment /> },
        ]}
      />
    </SectionWrapper>
  );
};
export default Dimensions;
